module.exports = __webpack_public_path__ + "static/vertihwg-5c4ea1695d38a9ae0bde57991fb44004.jpg";